import { Message, MessageBox } from 'element-ui';

export default {
  install(Vue) {
    Vue.prototype.$errorToast = (msg) => {
      Message({
        message: msg,
        type: 'error',
        duration: 3000,
      });
    }
    Vue.prototype.$warningToast = (msg) => {
      Message({
        message: msg,
        type: 'warning',
        duration: 3000,
      });
    }
    Vue.prototype.$successToast = (msg) => {
      Message({
        message: msg,
        type: 'success',
        duration: 3000,
      });
    }
    Vue.prototype.$confirmDelete = (msg, callback, title = '提示', type = 'warning') => {
      MessageBox.confirm(msg, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type,
      }).then(() => {
        callback();
      }).catch(() => {
      });
    };
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/mbt.js